import {Subscription} from 'rxjs';
import {MediaChange, MediaObserver} from '@angular/flex-layout';
import {Component, OnDestroy, OnInit, AfterViewInit } from '@angular/core';
import {LayoutService} from '../layout.service';
import {ServerUrls} from "../../server-url-constants";

@Component({
  selector: 'portal-layout-compact',
  templateUrl: './layout-compact.component.html',
  styleUrls: ['./layout-compact.component.scss']
})
export class LayoutCompactComponent implements OnInit, OnDestroy, AfterViewInit {
  /**
   * Stores if left sidenav is open.
   */
  leftSidenavOpen: boolean;

  /**
   * Stores left sidenav display mode.
   */
  leftSidenavMode: string;

  /**
   * Stores media observable subscription.
   */
  mediaSubscription: Subscription;
  public sideNavPosition: string = 'start';
  public isNOFA: boolean = ServerUrls.IS_NOFA;

  constructor(
    private media: MediaObserver,
    public layoutService: LayoutService
  ) {}

  ngOnInit(): void {
    // Get initial state of the sidenav.
    this.calculateSidenavStatus();

    // Subscribe to changes in screen size to change sidenav behavior.
    this.mediaSubscription = this.media.asObservable()
      .subscribe((change: MediaChange[]) => this.calculateSidenavStatus());
  }

  // 2. Implement ngAfterViewInit to fix the Axe issue
  ngAfterViewInit(): void {
    this.fixFocusTrapAnchors();
  }

  /**
   * Fixes Axe issue: ARIA hidden element must not be focusable.
   * Targets CDK focus trap anchors that are hidden from ARIA but have tabindex="0".
   */
  private fixFocusTrapAnchors(): void {
    const runFix = () => {
      const hiddenAnchors = document.querySelectorAll('.cdk-focus-trap-anchor[aria-hidden="true"]');
      hiddenAnchors.forEach(anchor => {
        // Change from '0' (focusable) to '-1' (not focusable via Tab)
        if (anchor.getAttribute('tabindex') !== '-1') {
          anchor.setAttribute('tabindex', '-1');
        }
      });
    };

    // Run once immediately
    setTimeout(runFix, 500);

    // Also run when the window is clicked or keys are pressed, 
    // as the Sidenav often re-renders anchors when toggled.
    window.addEventListener('click', runFix);
  }

   skipContent(event: Event): void {
    event.preventDefault();
    setTimeout(() => {
      const searchInput = document.getElementById('card-view-application') as HTMLInputElement;
       const homepageLink = document.getElementById('join-mailing-list-link') as HTMLInputElement;
       const backBtn = document.getElementById('BTN-BACK') as HTMLInputElement;
       const btnResetFilter = document.querySelector('.reset-filter-btn') as HTMLInputElement;
       const btnAskQuestion = document.querySelector('.ask-question-btn') as HTMLInputElement;
       const esriMap = document.getElementById('app-esri-map') as HTMLInputElement;
      if (searchInput) {
        searchInput.scrollIntoView({ behavior: 'smooth' });
        searchInput.focus();
      }else if (homepageLink) {
        homepageLink.scrollIntoView({ behavior: 'smooth' });
        homepageLink.focus();
      }else if (backBtn) {
        backBtn.scrollIntoView({ behavior: 'smooth' });
        backBtn.focus();
      }else if (btnResetFilter) {
        
        if (btnAskQuestion) {
          btnAskQuestion.scrollIntoView({ behavior: 'smooth' });
          btnAskQuestion.focus();
        }else{
          btnResetFilter.scrollIntoView({ behavior: 'smooth' });
          btnResetFilter.focus();
        }
      }else if (btnAskQuestion) {
        btnAskQuestion.scrollIntoView({ behavior: 'smooth' });
        btnAskQuestion.focus();
      }else if (esriMap) {
        esriMap.scrollIntoView({ behavior: 'smooth' });
        esriMap.focus();
      }
    }, 100);
  }

  ngOnDestroy(): void {
    if (this.mediaSubscription) {
      this.mediaSubscription.unsubscribe();
    }
  }

  calculateSidenavStatus(): void {
    const isMobile = this.media.isActive('lt-md');
    // Close sidenav on mobile.
    this.leftSidenavOpen = !isMobile;
    // Make sidenav open over content on mobile.
    this.leftSidenavMode = isMobile ? 'over' : 'side';
  }
}
